/*
 * Captures Chrome's `beforeinstallprompt` event.
 *
 * This module registers its listener at import time — imported from src/index.js
 * before React renders — because Chrome can fire the event before the React tree
 * mounts. A component-level listener would miss it and the install button would
 * never appear.
 *
 * calling preventDefault() suppresses Chrome's own "mini-infobar". That is
 * intentional: the infobar shows at most once, is suppressed for ~90 days after a
 * dismissal, and never appears when the app is already installed, so it cannot be
 * relied on. We show our own always-available button instead — see
 * src/components/common/InstallAppPrompt.js.
 */

export const INSTALL_PROMPT_EVENT = "mapit:installable";

let deferredPrompt = null;

/** The stashed event, or null if Chrome has not offered installation. */
export const getDeferredInstallPrompt = () => deferredPrompt;

export const registerInstallPromptListener = () => {
  if (typeof window === "undefined") return;

  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    deferredPrompt = event;
    // Let the UI know an install is available, whenever it happens to mount.
    window.dispatchEvent(new Event(INSTALL_PROMPT_EVENT));
  });

  window.addEventListener("appinstalled", () => {
    // Single-use: once installed the stashed event must not be reused.
    deferredPrompt = null;
  });
};
